module.exports = __webpack_public_path__ + "img/add-note.2e35e459.svg";